import styled from "../../styled-components";

export const StyledHeading = styled.h1`
  font-size: ${props => props.theme.fontSizes._30};
`;

export const StyledSubHeading = styled.h2`
  font-size: ${props => props.theme.fontSizes._20};
`;
